import { render } from "./HakafaM.vue?vue&type=template&id=12aa4437&scoped=true"
import script from "./HakafaM.vue?vue&type=script&lang=js"
export * from "./HakafaM.vue?vue&type=script&lang=js"

import "./HakafaM.vue?vue&type=style&index=0&id=12aa4437&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12aa4437"]])

export default __exports__